import React, { useMemo } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import Autopilot from "../../views/Autopilot";
import AutopilotChat from "../../views/Autopilot/AutopilotChat";
import Perfil from "../../views/Conta/Perfil";
import Preferencias from "../../views/Conta/Preferencias";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";
// react plugin for creating notifications over the dashboard
import NotificationAlert from "react-notification-alert";

// core components
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import Footer from "components/Footer/Footer.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import FixedPlugin from "components/FixedPlugin/FixedPlugin.js";

// Menu produto-first (PO1-1974)
import { useAuth } from "../../hooks/auth";
import { useFeatures } from "../../hooks/features";
import { useActiveProduct } from "../../hooks/activeProduct";
import {
  filterMenuForUser,
  LEGACY_REDIRECTS,
  buscaDoRedirect,
  rotaInicial,
  rotasDoProduto,
} from "../../routes/products";
// PO1-2381: <Route> com guard de URL (`authorized` → "Sem acesso").
import RotaGuardada from "../../routes/Route";
// PO1-3506: catálogo de tutoriais do produto ativo + "já vi", para o ícone
// "Como usar esta tela" do cabeçalho.
import { TreinamentoProvider } from "../../contexts/TreinamentoContext";

import logo from "assets/img/logo2.png";

var ps;

class Admin extends React.Component {
  constructor(props) {
    super(props);
    const hasWindow = typeof window !== "undefined";
    const storage = hasWindow ? window.localStorage : null;
    const storedActiveColor = storage
      ? storage.getItem("@HubEverlog:activeColor")
      : null;
    const storedSidebarMini = storage
      ? storage.getItem("@HubEverlog:sidebarMini")
      : null;
    const storedUser = storage ? storage.getItem("@HubEverlog:user") : null;

    this.state = {
      activeColor: storedActiveColor || "blue",
      sidebarMini:
        storedSidebarMini !== null ? storedSidebarMini === "true" : true,
      opacity: 0,
      sidebarOpened: false,
      routes: props.computedRoutes || [],
      user: storedUser ? JSON.parse(storedUser) : null,
    };
  }

  componentDidMount() {
    if (typeof document !== "undefined") {
      if (this.state.sidebarMini) {
        document.body.classList.add("sidebar-mini");
      } else {
        document.body.classList.remove("sidebar-mini");
      }
    }

    if (navigator.platform.indexOf("Win") > -1) {
      document.documentElement.classList.add("perfect-scrollbar-on");
      document.documentElement.classList.remove("perfect-scrollbar-off");
      ps = new PerfectScrollbar(this.refs.mainPanel);
      this.refs.mainPanel.addEventListener(
        "ps-scroll-y",
        this.showNavbarButton
      );
      let tables = document.querySelectorAll(".table-responsive");
      for (let i = 0; i < tables.length; i++) {
        ps = new PerfectScrollbar(tables[i]);
      }
    }
    window.addEventListener("scroll", this.showNavbarButton);
  }
  componentWillUnmount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps.destroy();
      document.documentElement.className.add("perfect-scrollbar-off");
      document.documentElement.classList.remove("perfect-scrollbar-on");
      this.refs.mainPanel.removeEventListener(
        "ps-scroll-y",
        this.showNavbarButton
      );
    }
    window.removeEventListener("scroll", this.showNavbarButton);
  }
  componentDidUpdate(prevProps) {
    // Atualiza menu quando o wrapper (AdminWithRoutes) recomputa pelas mudanças
    // de produto ativo, features ou permissões.
    if (prevProps.computedRoutes !== this.props.computedRoutes) {
      this.setState({ routes: this.props.computedRoutes || [] });
    }

    if (prevProps.location.pathname !== this.props.location.pathname) {
      if (navigator.platform.indexOf("Win") > -1) {
        let tables = document.querySelectorAll(".table-responsive");
        for (let i = 0; i < tables.length; i++) {
          ps = new PerfectScrollbar(tables[i]);
        }
      }
      document.documentElement.scrollTop = 0;
      document.scrollingElement.scrollTop = 0;
      this.refs.mainPanel.scrollTop = 0;
    }
  }
  showNavbarButton = () => {
    if (
      document.documentElement.scrollTop > 50 ||
      document.scrollingElement.scrollTop > 50 ||
      this.refs.mainPanel.scrollTop > 50
    ) {
      this.setState({ opacity: 1 });
    } else if (
      document.documentElement.scrollTop <= 50 ||
      document.scrollingElement.scrollTop <= 50 ||
      this.refs.mainPanel.scrollTop <= 50
    ) {
      this.setState({ opacity: 0 });
    }
  };
  // PO1-2381: as rotas vêm da árvore do produto filtrada só por feature
  // (rotasDoProduto); a permissão é conferida aqui pelo Route guardado, com o
  // mesmo `authorized` do item de menu. Quem vê o item entra pela URL; quem não
  // vê recebe "Sem acesso" em vez do redirect silencioso para a aterrissagem.
  getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return this.getRoutes(prop.views);
      }
      if (prop.layout === "/app") {
        return (
          <RotaGuardada
            path={prop.layout + prop.path}
            exact={prop.exact}
            component={prop.component}
            authorized={prop.authorized}
            isPrivate
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };
  getActiveRoute = (routes) => {
    let activeRoute = "Default Brand Text";
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveRoute = this.getActiveRoute(routes[i].views);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else {
        const fullPath = routes[i].layout + routes[i].path;
        // Rotas `exact` (ex: Listagem) só casam o caminho inteiro; senão o
        // prefixo /cadastros/tabelas-frete casaria /nova e /importar e o
        // breadcrumb mostraria "Listagem" em todas as telas.
        const matches = routes[i].exact
          ? window.location.pathname === fullPath
          : window.location.pathname.indexOf(fullPath) !== -1;
        if (matches) {
          return routes[i].name;
        }
      }
    }
    return activeRoute;
  };
  handleActiveClick = (color) => {
    this.setState({ activeColor: color });
    if (typeof window !== "undefined") {
      window.localStorage.setItem("@HubEverlog:activeColor", color);
    }
  };
  handleMiniClick = () => {
    const nextSidebarMini = !this.state.sidebarMini;
    this.setState({ sidebarMini: nextSidebarMini });
    if (typeof document !== "undefined") {
      document.body.classList.toggle("sidebar-mini");
    }
    if (typeof window !== "undefined") {
      window.localStorage.setItem(
        "@HubEverlog:sidebarMini",
        String(nextSidebarMini)
      );
    }
  };
  toggleSidebar = () => {
    this.setState({
      sidebarOpened: !this.state.sidebarOpened,
    });
    document.documentElement.classList.toggle("nav-open");
  };
  closeSidebar = () => {
    this.setState({
      sidebarOpened: false,
    });
    document.documentElement.classList.remove("nav-open");
  };
  render() {
    // PO1-3106: transportadora em modo habilitação vê só o painel — sem
    // Sidebar, sem minimizar e sem as rotas fixas do Autopilot; qualquer outra
    // URL volta para /app/habilitacao. A engrenagem de preferências CONTINUA
    // (20/09/2026): ver o comentário no FixedPlugin, no fim deste render.
    // PO1-2287: a transportadora homologada usa o produto MeuFrete; as rotas
    // fixas do Autopilot e do chat não são montadas para ela (o servidor
    // responde 403), e o fallback é a aterrissagem do produto.
    const emHabilitacao = !!this.props.emHabilitacao;
    const semAutopilot = emHabilitacao || !!this.props.semAutopilot;
    const rotaFallback = this.props.rotaFallback || "/app/autopilot";
    return (
      <div className="wrapper">
        <div className="rna-container">
          <NotificationAlert ref="notificationAlert" />
        </div>
        {!emHabilitacao && (
          <div
            className="navbar-minimize-fixed"
            style={{ opacity: this.state.opacity }}
          >
            <button
              className="minimize-sidebar btn btn-link btn-just-icon"
              onClick={this.handleMiniClick}
            >
              <i className="tim-icons icon-align-center visible-on-sidebar-regular text-muted" />
              <i className="tim-icons icon-bullet-list-67 visible-on-sidebar-mini text-muted" />
            </button>
          </div>
        )}
        {!emHabilitacao && (
          <Sidebar
            {...this.props}
            routes={this.state.routes}
            activeColor={this.state.activeColor}
            logo={{
              outterLink: "https://www.everlogbrasil.com.br",
              text: "Everlog",
              imgSrc: logo,
            }}
            closeSidebar={this.closeSidebar}
          />
        )}
        <div
          className="main-panel"
          ref="mainPanel"
          data={this.state.activeColor}
          style={emHabilitacao ? { width: "100%" } : undefined}
        >
          <AdminNavbar
            {...this.props}
            activeColor={this.state.activeColor}
            handleMiniClick={this.handleMiniClick}
            brandText={this.getActiveRoute(this.props.rotasGuardadas || this.state.routes)}
            sidebarOpened={this.state.sidebarOpened}
            toggleSidebar={this.toggleSidebar}
          />
          <Switch>
            {!semAutopilot && <Route path="/app/autopilot/chat" component={AutopilotChat} />}
            {/* Rota fallback fixa pro Autopilot — garante que /app/autopilot
                resolva mesmo enquanto useFeatures() ainda carrega (senão o
                <Redirect from="*"> abaixo entraria em loop). */}
            {!semAutopilot && <Route exact path="/app/autopilot" component={Autopilot} />}
            {/* Telas da área "Minha conta" — acionadas pelo avatar dropdown
                (PO1-1976). Rotas fixas porque não pertencem a produto. */}
            <Route exact path="/app/minha-conta/perfil" component={Perfil} />
            <Route
              exact
              path="/app/minha-conta/preferencias"
              component={Preferencias}
            />
            {/* PO1-1975: redirects de URLs antigas pras novas com prefixo
                de produto. Bookmarks externos continuam funcionando. */}
            {/* Preserva a query string: a Pesquisa Importação virou a Consulta
                NFe (31/10/2026) e os filtros vêm na URL compartilhada. */}
            {LEGACY_REDIRECTS.map((r) => (
              <Route
                key={r.from}
                exact
                path={r.from}
                render={({ location }) => <Redirect to={{ pathname: r.to, search: buscaDoRedirect(r, location.search) }} />}
              />
            ))}
            {this.getRoutes(this.props.rotasGuardadas || this.state.routes)}
            {/* PO1-2713: o fallback só entra depois da primeira carga de
                features. Antes disso as rotas de produto ainda não existem e
                o Redirect engoliria deep links (ex.: ?abrir=<id> do e-mail da
                alçada) na carga fria da página. */}
            {this.props.routesReady && <Redirect from="*" to={rotaFallback} />}
          </Switch>
          {
            // we don't want the Footer to be rendered on full screen maps page
            this.props.location.pathname.indexOf("full-screen-map") !==
            -1 ? null : (
              <Footer fluid />
            )
          }
        </div>
        {/*
          A engrenagem de preferências vale TAMBÉM na habilitação (pedido do Rodrigo
          em 20/09/2026: "no acesso do transportador não tem aquela engrenagem que
          controla as cores e os temas"). Ela tinha sido escondida junto com a
          Sidebar na PO1-3106, mas não depende dela: o componente só usa
          `activeColor`/`handleActiveClick`, e modo claro/escuro é conforto visual
          que a transportadora precisa desde o primeiro acesso — justamente quando
          ela passa mais tempo numa tela só.
          Sem a legenda dinâmica ali: não há gráfico no painel de habilitação.
        */}
        <FixedPlugin
          activeColor={this.state.activeColor}
          handleActiveClick={this.handleActiveClick}
          mostrarLegenda={!emHabilitacao}
        />
      </div>
    );
  }
}

// Wrapper functional que computa o menu via hooks (PO1-1974). Passa pra
// classe Admin via prop `computedRoutes` pra preservar a infra de scroll/sidebar
// existente sem reescrever tudo em hooks.
function AdminWithRoutes(props) {
  const { user } = useAuth();
  const { codes, loadedOnce: featuresLoadedOnce } = useFeatures();
  const { activeProduct } = useActiveProduct();

  const computedRoutes = useMemo(() => {
    if (!user) return [];

    const permissions = user.permissions || [];
    const setor = user.setor;

    // PO1-3166 (20/09/2026): a transportadora em habilitação NÃO tem mais um
    // menu próprio. "Se tem usuário e senha, entra no portal normal" — ela vê o
    // MeuFrete completo, e acompanha a esteira pelo item Embarcadores.
    //
    // O que derrubou a regra anterior: ela era "em habilitação enquanto NENHUM
    // vínculo estiver homologado", e o backfill da PO1-3166 homologou todo o
    // legado. Uma transportadora que atende cinco embarcadores e entra no sexto
    // saía do painel e ficava sem lugar para ver esse sexto.

    // PO1-2287: a transportadora entra no produto-first como os demais: o
    // backend manda a feature MEUFRETE e o activeProduct resolve para ela.
    if (!activeProduct) return [];

    const isAdmin = setor === "admin";
    return filterMenuForUser(activeProduct, {
      features: codes,
      permissions,
      isAdmin,
    });
  }, [user, codes, activeProduct]);

  // PO1-2381: rotas do produto por feature (sem o corte de permissão); o
  // Route guardado mostra "Sem acesso" quando falta a permissão do item.
  const rotasGuardadas = useMemo(() => {
    if (!user || !activeProduct) return [];
    return rotasDoProduto(activeProduct, { features: codes });
  }, [user, codes, activeProduct]);

  // Espera a 1ª carga das features (a transportadora depende da feature
  // MEUFRETE, PO1-2287). Não há mais menu fixo de habilitação.
  const emHabilitacao = false;
  const routesReady = featuresLoadedOnce;
  const semAutopilot = !!(user && user.setor === "transportadora");

  return (
    <TreinamentoProvider>
      <Admin
        {...props}
        computedRoutes={computedRoutes}
        rotasGuardadas={rotasGuardadas}
        routesReady={routesReady}
        emHabilitacao={emHabilitacao}
        semAutopilot={semAutopilot}
        rotaFallback={rotaInicial(user)}
      />
    </TreinamentoProvider>
  );
}

export default AdminWithRoutes;
